const MuiRadio = {
  styleOverrides: {
    root: {
      '&&:hover': {
        backgroundColor: 'transparent !important',
      },
    },
  },
};

export default MuiRadio;
